<template>
  <div
    v-if="value"
    style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(22, 22, 22, 0.6); z-index: 9999;"
    @click.self="doClose"
  >
    <div
      style="position: absolute; top: 120px; left: 0; right: 0; bottom: 0; text-align: center; background: #ffffff; border-radius: 16px 16px 0 0;"
    >
      <img
        src="https://zcmo.oss-cn-shenzhen.aliyuncs.com/imgsys/2024/12/26/07-59-1735171160792.jpg"
        style="position: absolute; right: 8px; top: 8px; width: 24px; height: 24px;"
        @click="doClose"
      />

      <div style="padding: 35px 12px 20px 12px; text-align: left;">
        <van-search
          v-model="keyword"
          placeholder="请输入合同号或者订单号"
          show-action
          shape="round"
          @search="onSearch"
        >
          <template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>

        <div
          style="position: absolute; left: 0; right: 0; bottom: 0; top: 89px; padding: 0 18px; overflow-y: scroll;"
        >
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div
              v-for="(item, index) in list"
              :key="item.id || index"
              style="border-bottom: 1px solid #efefef; padding: 16px 8px;box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.12), 0px 4px 8px rgba(0, 0, 0, 0.08);margin-bottom: 16px;border-radius: 16px;"
              @click="selectContract(item)"
            >
              <div class="cus-row cus-row-v-m">
                <div class="cus-row-col-12">
                  <span class="ffm f-c-212120 s-32-45">{{ item.real_name }}</span>
                  <span class="ffr f-c-b5b5b5 s-24-33" style="margin-left: 6px;">线路：{{ item.contract_name }}</span>
                </div>
                
              </div>

              <div style="margin-top: 0.2rem" class="in-bl-line">
                <span class="ffr f-c-757575 s-28-40" style="font-weight: bold">{{ item.contract_main_name }}</span>
              </div>

              <div class="cus-row cus-row-v-m" style="margin-top: 0.16rem">
                <div class="cus-row-col-8" v-if="item.contract_numbe">
                  <span class="ffr f-c-b5b5b5 s-24-33">合同号：{{ item.contract_numbe }}</span>
                </div>
                <div class="cus-row-col-8" v-else>
                  <span class="ffr f-c-b5b5b5 s-24-33">订单号：{{ item.bill_no }}</span>
                </div>
                <div class="cus-row-col-4 t-al-r">
                  <span class="ffr f-c-b5b5b5 s-24-33">{{ item.valid_date }}</span>
                </div>
              </div>
            </div>
          </van-list>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import common from '@/assets/js/common'

export default {
  name: 'ContractPicker',
  model: { prop: 'value', event: 'selectterm' },
  props: {
    value: { type: Boolean, default: false }
  },
  data () {
    return {
      keyword: '',
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      pageNo: 0,
      serach_key: ''
    }
  },
  methods: {
    doClose () {
      this.$emit('selectterm', false)
    },
    selectContract (item) {
      this.$emit('selected', item)
      this.$emit('selectterm', false)
    },
    onSearch () {
      this.serach_key = this.keyword
      this.onRefresh()
    },
    onLoad () {
      if (this.refreshing) {
        this.list = []
        this.refreshing = false
      }

      common
        .cusHttp(this, '/admin_user.php?action=job_list', { pageNo: this.pageNo, pageSize: 12, keyword: this.serach_key, contract_state: 3 }, 'get')
        .then(res => {
          res = JSON.parse(res.data)
          if (res.errcode === 200) {
            if (!res.result.data.length) {
              this.finished = true
              this.loading = false
              return
            }

            // 去重后追加
            for (let i = 0; i < res.result.data.length; i++) {
              const item = res.result.data[i]
              if (!this.list.find(v => v.id === item.id)) {
                this.list.push(item)
              }
            }
            this.pageNo = this.pageNo + 1
            this.loading = false
          }
        })
    },
    onRefresh () {
      this.refreshing = true
      this.finished = false
      this.loading = true
      this.pageNo = 1
      this.onLoad()
    }
  }
}
</script>

<style scoped>
.status-btn{
  background-color: #f5f5f5;
  border-radius: 0.24rem;
  padding: 0 0.37rem 0 0.21rem;
  line-height: 0.45rem;
  font-family: PingFangSC-Regular;
  font-size: 0.24rem;
  color: #111111;
  display: inline-block;
  position: relative;
}
</style>


